module.exports = __webpack_public_path__ + "static/testimonial-1-946ad92653ea6d22214dbfcdb841e122.png";